export default __webpack_public_path__ + "static/media/skins-header-bg2.03478788.png";